// ═══════════════════════════════════════════════════════════════════
//  modules/chat/utils.js
//  categoriesForProject · categoriesForCategory · sujFusion · sujCanauxTexte · sujDateCourte · sujDateLongue · sujJourLong
// ═══════════════════════════════════════════════════════════════════

import { CATEGORY_LABELS } from "../projets/constantes";
import { CHAT_PROJECT_NAME, CHAT_TASK_CATEGORIES, SUJ_CANAL_COURT } from "./constantes";

// Catégories visibles pour un projet donné :
// « Analyse Chat » ne montre que ses 3 catégories, les autres projets gardent les 10 d'origine.
export function categoriesForProject(project) {
  const estChat = !!project && project.name === CHAT_PROJECT_NAME;
  return Object.entries(CATEGORY_LABELS).filter(([k]) =>
    estChat ? CHAT_TASK_CATEGORIES.includes(k) : !CHAT_TASK_CATEGORIES.includes(k));
}

// Même logique, mais déduite d'une catégorie (pour le sélecteur de NewTaskModal — étape facultative).
export function categoriesForCategory(cat) {
  const estChat = CHAT_TASK_CATEGORIES.includes(cat);
  return Object.entries(CATEGORY_LABELS).filter(([k]) =>
    estChat ? CHAT_TASK_CATEGORIES.includes(k) : !CHAT_TASK_CATEGORIES.includes(k));
}

export function sujFusion(sujet) {
  const cx = (sujet && sujet.canaux) || [];
  if (cx.length < 2) return null;
  const occ = (sujet && sujet.occ_canaux) || {};
  return "🔀 " + cx.map((c) => `${SUJ_CANAL_COURT[c] || c}${occ[c] ? ` ${occ[c]}` : ""}`).join(" · ");
}

export function sujCanauxTexte(sujet) {
  return ((sujet && sujet.canaux) || []).map((c) => SUJ_CANAL_COURT[c] || c).join(" + ");
}

// ── Helpers ───────────────────────────────────────────────────────────
export function sujDateCourte(v) {
  if (!v) return "—";
  const d = new Date(v);
  if (isNaN(d.getTime())) return "—";
  return d.toDateString() === new Date().toDateString()
    ? d.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" })
    : d.toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit" });
}

export function sujDateLongue(v) {
  if (!v) return "—";
  const d = new Date(v);
  return isNaN(d.getTime()) ? "—" : d.toLocaleString("fr-FR");
}

export function sujJourLong(jour) {
  if (!jour) return "—";
  const d = new Date(`${jour}T12:00:00`);
  return isNaN(d.getTime()) ? jour : d.toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long" });
}
